import React from 'react'

function LoaderSecondary() {
  return (
    <div className="update-card-loading">
      <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default LoaderSecondary
